import { DateTime, Info } from "luxon";

function currency(number, locale = "en-US", currencyCode = "USD") {
  const formatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return formatter.format(number);
}

function standardDate(date, locale = "en", format = "d MMMM yyyy") {
  let dt = DateTime.fromISO(date, { locale });
  return dt.toFormat(format);
}

function standardDay(date, locale = "en") {
  let dt = DateTime.fromISO(date, { locale });
  return dt.weekdayLong;
}

function dateNow(locale = "en", format = "d MMMM yyyy") {
  let dt = DateTime.fromISO(DateTime.now(), { locale });
  return dt.toFormat(format);
}

function dateForInput(date) {
  let dt = DateTime.fromISO(date);
  return dt.toFormat('yyyy-MM-dd');
}

// Get the day of week (0 = Sunday, 6 = Saturday)
function dateExcel(rawDate){
    // Check if the date is a number (Excel serial date)
    if (!isNaN(rawDate) && rawDate.toString().indexOf("/") === -1) {
      // Excel date serial number (days since 1900-01-01)
      const excelDate = parseInt(rawDate);
      // const baseDate = new Date(Date.UTC(1900, 0, 1)); // Use UTC to avoid timezone offset
      const targetDate = new Date(Date.UTC(1900, 0, excelDate - 1)); // Directly set the day using UTC
      // console.log(targetDate);
      // console.log(convertDateWithoutTimezone(targetDate?.toISOString().split("T")[0]));
      const year = targetDate.getUTCFullYear();
      const month = String(targetDate.getUTCMonth() + 1).padStart(
        2,
        "0"
      );
      const day = String(targetDate.getUTCDate()).padStart(2, "0");
      console.log(targetDate)
      return targetDate;
    } else {
      // Regular DD/MM/YYYY format
      const [day, month, year] = rawDate.split("/");
      console.log(new Date(rawDate))
      return new Date(rawDate);
    }
  };

export default {
  currency,
  standardDate,
  standardDay,
  dateNow,
  dateForInput,
  dateExcel
};

export { currency, standardDate, standardDay, dateNow, dateForInput, dateExcel };
